import { render, staticRenderFns } from "./layout-site.vue?vue&type=template&id=6fdaf984"
import script from "./layout-site.vue?vue&type=script&lang=js"
export * from "./layout-site.vue?vue&type=script&lang=js"
import style0 from "./layout-site.vue?vue&type=style&index=0&id=6fdaf984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports